module.exports = __webpack_public_path__ + "img/bg1.b474d91.png";